module.exports = __webpack_public_path__ + "static/img/about5.1e4b5fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/about5.png
// module id = Gr4A
// module chunks = 0